require("../jquery.matchHeight-min");
$(document).ready(function () {
  $(".bikmo-quote-block__card__text").matchHeight();
  $(".bikmo-quote-block__card__cost").matchHeight();
  $(".bikmo-quote-block__card__select-cover").matchHeight();
  $(".radio-toolbar--cards .card").matchHeight();
  $(".section--insured-details .card").matchHeight();
});
